var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 10,
    viewBox: "0 0 2 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M1.7541 0L1.57377 7.11238H0.327869L0.147541 0H1.7541ZM1.01639 10C0.73224 10 0.491803 9.91465 0.295082 9.74396C0.0983607 9.57326 0 9.36463 0 9.11807C0 8.8715 0.0983607 8.66287 0.295082 8.49218C0.491803 8.32148 0.73224 8.23613 1.01639 8.23613C1.28962 8.23613 1.51913 8.32148 1.70492 8.49218C1.90164 8.66287 2 8.8715 2 9.11807C2 9.36463 1.90164 9.57326 1.70492 9.74396C1.51913 9.91465 1.28962 10 1.01639 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWhite);
export default __webpack_public_path__ + "static/media/warning-white.cfd65079acba621c553c60a8f137db8f.svg";
export { ForwardRef as ReactComponent };